import React from "react";
import { Plus, Trash2 } from "lucide-react";
import { fmtPrice } from "../../../lib/format";
import { resolveImg } from "../../../lib/api";
import { emptyProduct } from "../shared";

export function ProductsTab({ ctx }) {
  const { products, setEditing, deleteProduct } = ctx;
  return (
      <div>
        <div className="flex justify-between items-center mb-8">
          <h1 className="serif text-3xl">Products</h1>
          <button onClick={() => setEditing({ ...emptyProduct })} data-testid="admin-add-product" className="flex items-center gap-2 bg-[#C49A6C] text-[#0B0A08] text-xs uppercase tracking-[0.2em] px-5 py-3 hover:bg-[#E7CBA9]"><Plus size={15} /> Add</button>
        </div>
        <div className="border border-[#262421] divide-y divide-[#262421]">
          {products.map((p) => (
            <div key={p.id} className="flex items-center gap-4 p-4" data-testid={`admin-product-${p.slug}`}>
              <div className="w-12 h-14 bg-[#141311] overflow-hidden flex-shrink-0">{p.images?.[0] && <img src={resolveImg(p.images[0])} alt="" className="w-full h-full object-cover" />}</div>
              <div className="flex-1 min-w-0">
                <p className="serif text-lg">{p.name_en}</p>
                <p className="text-xs text-[#8A857D]">{fmtPrice(p.price, "AED")} · Stock {p.stock} · {p.status}</p>
              </div>
              <button onClick={() => setEditing(p)} data-testid={`admin-edit-${p.slug}`} className="text-xs uppercase tracking-widest text-[#C49A6C] hover:underline">Edit</button>
              <button onClick={() => deleteProduct(p.id)} className="text-[#6E685F] hover:text-[#c88]"><Trash2 size={16} /></button>
            </div>
          ))}
        </div>
      </div>
  );
}
